module.exports = __webpack_public_path__ + "media/images/lb/248-2546767776e0f27038e8f2ec78eabe3a.svg";